
export default "/assets/h2-micro.dee16530.svg"